class LoadMoreProducts extends HTMLElement {
  connectedCallback() {
    this.bindButton();
  }

  bindButton() {
    this.button = this.querySelector('.load-more-products__button');
    if (this.button) {
      this.button.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(event) {
    event.preventDefault();

    const nextUrl = this.dataset.nextUrl;
    if (!nextUrl) return;

    this.button.setAttribute('aria-busy', 'true');
    this.button.disabled = true;

    const separator = nextUrl.includes('?') ? '&' : '?';
    const url = `${nextUrl}${separator}section_id=${this.dataset.sectionId}`;

    fetch(url)
      .then((response) => response.text())
      .then((html) => this.renderNewProducts(html))
      .catch((error) => console.error(error))
      .finally(() => {
        if (this.button) {
          this.button.removeAttribute('aria-busy');
          this.button.disabled = false;
        }
      });
  }

  renderNewProducts(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const gridId = this.dataset.gridId || 'product-grid';
    const currentGrid = document.getElementById(gridId);
    const newGridItems = parsedHTML.getElementById(gridId);
    let firstNewItem = null;

    if (currentGrid && newGridItems) {
      Array.from(newGridItems.children).forEach((item, index) => {
        if (index === 0) firstNewItem = item;
        currentGrid.appendChild(item);
      });
    }

    const newLoadMore = parsedHTML.querySelector('load-more-products');
    if (newLoadMore) {
      this.innerHTML = newLoadMore.innerHTML;
      if (newLoadMore.dataset.nextUrl) {
        this.dataset.nextUrl = newLoadMore.dataset.nextUrl;
      } else {
        delete this.dataset.nextUrl;
      }
      this.bindButton();
    } else {
      this.remove();
    }

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger();
    }

    // Move focus to the first newly loaded product so keyboard/screen-reader
    // users land on new content instead of losing their place.
    if (firstNewItem) {
      const focusTarget = firstNewItem.querySelector('a, button') || firstNewItem;
      focusTarget.setAttribute('tabindex', '-1');
      focusTarget.focus();
    }
  }
}

customElements.define('load-more-products', LoadMoreProducts);
